/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const agreeCognitoUserF = /* GraphQL */ `mutation AgreeCognitoUserF($agreement: Boolean, $username: String!) {
  agreeCognitoUserF(agreement: $agreement, username: $username) {
    errorMessage
    item {
      Attributes {
        Name
        Value
        __typename
      }
      Company {
        address
        areaNames
        areaPrefs
        areas
        bldConditionCompanies
        bldConditionSelections
        branchAddress
        branchFax
        branchId
        branchName
        branchTel
        branchUrl
        createdAt
        eAreaNames
        eAreas
        email
        estateTypes
        fax
        guaranter
        id
        infoName
        job
        latitude
        license
        licenseCount
        licenseNo
        licenser
        logoImg
        longitude
        name
        organization
        owner
        recNo
        remarks
        remarks2
        searchInfo
        startMark
        tel
        updatedAt
        url
        __typename
      }
      Enabled
      Groups {
        CreationDate
        Description
        GroupName
        LastModifiedDate
        Precedence
        RoleArn
        UserPoolId
        __typename
      }
      MFAOptions {
        AttributeName
        DeliveryMedium
        __typename
      }
      User {
        agreement
        authenticatedAt
        companyBranchName
        companyId
        companyName
        createdAt
        defaultCondition {
          alsoCreatedAtFrom
          alsoCreatedAtTo
          alsoPricedAtFrom
          alsoPricedAtTo
          areaPrefs
          areas
          bldConditionSelections
          companyRecNo
          completionYMFrom
          completionYMTo
          estatePriceFrom
          estatePriceTo
          estateTypes
          exceptForRent
          flat
          forRent
          petOk
          priceLabel
          purposeSummaryBs
          roomsFrom
          roomsTo
          squareAreaOfMansionFrom
          squareAreaOfMansionTo
          structureSummaries
          tsuboAreaFrom
          tsuboAreaTo
          tsuboLabel
          venderOnly
          __typename
        }
        email
        group
        infoName
        name
        nameRuby
        owner
        paid
        pricingAvailable
        role
        searchInfo
        tel
        trial
        trialEndAt
        updatedAt
        username
        __typename
      }
      UserCreateDate
      UserLastModifiedDate
      UserStatus
      Username
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AgreeCognitoUserFMutationVariables,
  APITypes.AgreeCognitoUserFMutation
>;
export const clearAreaOfDefaultConditionOfUserF = /* GraphQL */ `mutation ClearAreaOfDefaultConditionOfUserF($username: String!) {
  clearAreaOfDefaultConditionOfUserF(username: $username) {
    errorMessage
    item {
      Attributes {
        Name
        Value
        __typename
      }
      Company {
        address
        areaNames
        areaPrefs
        areas
        bldConditionCompanies
        bldConditionSelections
        branchAddress
        branchFax
        branchId
        branchName
        branchTel
        branchUrl
        createdAt
        eAreaNames
        eAreas
        email
        estateTypes
        fax
        guaranter
        id
        infoName
        job
        latitude
        license
        licenseCount
        licenseNo
        licenser
        logoImg
        longitude
        name
        organization
        owner
        recNo
        remarks
        remarks2
        searchInfo
        startMark
        tel
        updatedAt
        url
        __typename
      }
      Enabled
      Groups {
        CreationDate
        Description
        GroupName
        LastModifiedDate
        Precedence
        RoleArn
        UserPoolId
        __typename
      }
      MFAOptions {
        AttributeName
        DeliveryMedium
        __typename
      }
      User {
        agreement
        authenticatedAt
        companyBranchName
        companyId
        companyName
        createdAt
        defaultCondition {
          alsoCreatedAtFrom
          alsoCreatedAtTo
          alsoPricedAtFrom
          alsoPricedAtTo
          areaPrefs
          areas
          bldConditionSelections
          companyRecNo
          completionYMFrom
          completionYMTo
          estatePriceFrom
          estatePriceTo
          estateTypes
          exceptForRent
          flat
          forRent
          petOk
          priceLabel
          purposeSummaryBs
          roomsFrom
          roomsTo
          squareAreaOfMansionFrom
          squareAreaOfMansionTo
          structureSummaries
          tsuboAreaFrom
          tsuboAreaTo
          tsuboLabel
          venderOnly
          __typename
        }
        email
        group
        infoName
        name
        nameRuby
        owner
        paid
        pricingAvailable
        role
        searchInfo
        tel
        trial
        trialEndAt
        updatedAt
        username
        __typename
      }
      UserCreateDate
      UserLastModifiedDate
      UserStatus
      Username
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ClearAreaOfDefaultConditionOfUserFMutationVariables,
  APITypes.ClearAreaOfDefaultConditionOfUserFMutation
>;
export const convertEstateGroundToLotF = /* GraphQL */ `mutation ConvertEstateGroundToLotF($input: DeleteEstateInput!) {
  convertEstateGroundToLotF(input: $input) {
    errorMessage
    item {
      address
      appearanceImgs
      area
      balconyArea
      bcr
      bldConditionType
      buildingCompany
      buildingFloors
      cadastralMapPdf
      carsInParkingN
      city
      cityPlanningType
      cleaningMonth
      clearingType
      collectedAt
      companyAddress
      companyBranchId
      companyFax
      companyGuaranter
      companyId
      companyLicense
      companyName
      companyRecNo
      companyTel
      companyUrl
      completionMonth
      completionMonthS
      completionSchMonth
      condominiumId
      condominiumName
      condominiumRecNo
      confirmed
      createdAt
      currentStatus
      currentStatusB
      currentStatusFree
      currentStatusG
      deletedOnSumora
      drivewayPay
      eSchool
      estatePrice
      estateType
      estateUrl
      exactLocation
      floor
      floorAreaRatio
      floorStructure
      fullAddress
      gas
      gasPdf
      groundPdf
      groundType
      groundTypeFree
      id
      infoName
      isLot
      jSchool
      landAreaType
      landRights
      latitude
      layout
      layoutImgs
      license
      location
      longitude
      managementFee
      managementType
      manager
      mapImg
      media
      mediationKind
      name
      nearlyLocation
      notFoundAt
      otherCost
      owner
      parking
      parkingFee
      parkingHeight
      parkingMechOrPlane
      parkingTakeOver
      parkingTakeOverFree
      pet
      prefecture
      priceHistory {
        price
        pricedAt
        __typename
      }
      pricedAt
      purposeB
      purposeSummaryB
      recNo
      remarks
      repairCost
      roadDirection
      roadType
      roadWidth
      room
      searchInfo
      seller
      sewer
      sewerPdf
      sold
      squareArea
      status
      store
      structure
      structureFree
      subCompany2Address
      subCompany2Fax
      subCompany2Guaranter
      subCompany2Id
      subCompany2License
      subCompany2Name
      subCompany2Tel
      subCompany2Url
      subCompanyAddress
      subCompanyFax
      subCompanyGuaranter
      subCompanyId
      subCompanyLicense
      subCompanyName
      subCompanyRecNo
      subCompanyTel
      subCompanyUrl
      tileOnZoom12
      tileOnZoom14
      tileOnZoom16
      totalArea
      totalHouses
      traffic
      tsuboArea
      unitPrice
      unsettledLocation
      updatedAt
      url
      useDistrict
      water
      waterPdf
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ConvertEstateGroundToLotFMutationVariables,
  APITypes.ConvertEstateGroundToLotFMutation
>;
export const convertEstateLotToGroundF = /* GraphQL */ `mutation ConvertEstateLotToGroundF($input: DeleteEstateInput!) {
  convertEstateLotToGroundF(input: $input) {
    errorMessage
    item {
      address
      appearanceImgs
      area
      balconyArea
      bcr
      bldConditionType
      buildingCompany
      buildingFloors
      cadastralMapPdf
      carsInParkingN
      city
      cityPlanningType
      cleaningMonth
      clearingType
      collectedAt
      companyAddress
      companyBranchId
      companyFax
      companyGuaranter
      companyId
      companyLicense
      companyName
      companyRecNo
      companyTel
      companyUrl
      completionMonth
      completionMonthS
      completionSchMonth
      condominiumId
      condominiumName
      condominiumRecNo
      confirmed
      createdAt
      currentStatus
      currentStatusB
      currentStatusFree
      currentStatusG
      deletedOnSumora
      drivewayPay
      eSchool
      estatePrice
      estateType
      estateUrl
      exactLocation
      floor
      floorAreaRatio
      floorStructure
      fullAddress
      gas
      gasPdf
      groundPdf
      groundType
      groundTypeFree
      id
      infoName
      isLot
      jSchool
      landAreaType
      landRights
      latitude
      layout
      layoutImgs
      license
      location
      longitude
      managementFee
      managementType
      manager
      mapImg
      media
      mediationKind
      name
      nearlyLocation
      notFoundAt
      otherCost
      owner
      parking
      parkingFee
      parkingHeight
      parkingMechOrPlane
      parkingTakeOver
      parkingTakeOverFree
      pet
      prefecture
      priceHistory {
        price
        pricedAt
        __typename
      }
      pricedAt
      purposeB
      purposeSummaryB
      recNo
      remarks
      repairCost
      roadDirection
      roadType
      roadWidth
      room
      searchInfo
      seller
      sewer
      sewerPdf
      sold
      squareArea
      status
      store
      structure
      structureFree
      subCompany2Address
      subCompany2Fax
      subCompany2Guaranter
      subCompany2Id
      subCompany2License
      subCompany2Name
      subCompany2Tel
      subCompany2Url
      subCompanyAddress
      subCompanyFax
      subCompanyGuaranter
      subCompanyId
      subCompanyLicense
      subCompanyName
      subCompanyRecNo
      subCompanyTel
      subCompanyUrl
      tileOnZoom12
      tileOnZoom14
      tileOnZoom16
      totalArea
      totalHouses
      traffic
      tsuboArea
      unitPrice
      unsettledLocation
      updatedAt
      url
      useDistrict
      water
      waterPdf
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ConvertEstateLotToGroundFMutationVariables,
  APITypes.ConvertEstateLotToGroundFMutation
>;
export const createAnnounce = /* GraphQL */ `mutation CreateAnnounce(
  $condition: ModelAnnounceConditionInput
  $input: CreateAnnounceInput!
) {
  createAnnounce(condition: $condition, input: $input) {
    body
    createdAt
    expiredAt
    id
    level
    owner
    subject
    to
    updatedAt
    ym
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAnnounceMutationVariables,
  APITypes.CreateAnnounceMutation
>;
export const createBatchJob = /* GraphQL */ `mutation CreateBatchJob(
  $condition: ModelBatchJobConditionInput
  $input: CreateBatchJobInput!
) {
  createBatchJob(condition: $condition, input: $input) {
    createdAt
    expiredAt
    id
    jobName
    remarks
    status
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBatchJobMutationVariables,
  APITypes.CreateBatchJobMutation
>;
export const createBatchJobConf = /* GraphQL */ `mutation CreateBatchJobConf(
  $condition: ModelBatchJobConfConditionInput
  $input: CreateBatchJobConfInput!
) {
  createBatchJobConf(condition: $condition, input: $input) {
    allowedGroups
    createdAt
    jobName
    remarks
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBatchJobConfMutationVariables,
  APITypes.CreateBatchJobConfMutation
>;
export const createBuildPrice = /* GraphQL */ `mutation CreateBuildPrice(
  $condition: ModelBuildPriceConditionInput
  $input: CreateBuildPriceInput!
) {
  createBuildPrice(condition: $condition, input: $input) {
    createdAt
    owner
    unitPriceCB
    unitPriceOther
    unitPriceRC
    unitPriceS
    unitPriceSRC
    unitPriceW
    updatedAt
    year
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBuildPriceMutationVariables,
  APITypes.CreateBuildPriceMutation
>;
export const createCognitoUserF = /* GraphQL */ `mutation CreateCognitoUserF(
  $agreement: Boolean
  $companyId: String!
  $email: AWSEmail!
  $group: String!
  $name: String!
  $nameRuby: String!
  $paid: Boolean
  $password: String!
  $pricingAvailable: Boolean
  $role: String
  $tel: String
  $trial: Boolean
  $trialEndAt: AWSDateTime
  $username: String!
) {
  createCognitoUserF(
    agreement: $agreement
    companyId: $companyId
    email: $email
    group: $group
    name: $name
    nameRuby: $nameRuby
    paid: $paid
    password: $password
    pricingAvailable: $pricingAvailable
    role: $role
    tel: $tel
    trial: $trial
    trialEndAt: $trialEndAt
    username: $username
  ) {
    errorMessage
    item {
      Attributes {
        Name
        Value
        __typename
      }
      Company {
        address
        areaNames
        areaPrefs
        areas
        bldConditionCompanies
        bldConditionSelections
        branchAddress
        branchFax
        branchId
        branchName
        branchTel
        branchUrl
        createdAt
        eAreaNames
        eAreas
        email
        estateTypes
        fax
        guaranter
        id
        infoName
        job
        latitude
        license
        licenseCount
        licenseNo
        licenser
        logoImg
        longitude
        name
        organization
        owner
        recNo
        remarks
        remarks2
        searchInfo
        startMark
        tel
        updatedAt
        url
        __typename
      }
      Enabled
      Groups {
        CreationDate
        Description
        GroupName
        LastModifiedDate
        Precedence
        RoleArn
        UserPoolId
        __typename
      }
      MFAOptions {
        AttributeName
        DeliveryMedium
        __typename
      }
      User {
        agreement
        authenticatedAt
        companyBranchName
        companyId
        companyName
        createdAt
        defaultCondition {
          alsoCreatedAtFrom
          alsoCreatedAtTo
          alsoPricedAtFrom
          alsoPricedAtTo
          areaPrefs
          areas
          bldConditionSelections
          companyRecNo
          completionYMFrom
          completionYMTo
          estatePriceFrom
          estatePriceTo
          estateTypes
          exceptForRent
          flat
          forRent
          petOk
          priceLabel
          purposeSummaryBs
          roomsFrom
          roomsTo
          squareAreaOfMansionFrom
          squareAreaOfMansionTo
          structureSummaries
          tsuboAreaFrom
          tsuboAreaTo
          tsuboLabel
          venderOnly
          __typename
        }
        email
        group
        infoName
        name
        nameRuby
        owner
        paid
        pricingAvailable
        role
        searchInfo
        tel
        trial
        trialEndAt
        updatedAt
        username
        __typename
      }
      UserCreateDate
      UserLastModifiedDate
      UserStatus
      Username
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCognitoUserFMutationVariables,
  APITypes.CreateCognitoUserFMutation
>;
export const createDummy = /* GraphQL */ `mutation CreateDummy(
  $condition: ModelDummyConditionInput
  $input: CreateDummyInput!
) {
  createDummy(condition: $condition, input: $input) {
    createdAt
    id
    kintoneAppScope
    kintoneDataKind
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDummyMutationVariables,
  APITypes.CreateDummyMutation
>;
export const createEstateF = /* GraphQL */ `mutation CreateEstateF($input: CreateEstateInput!) {
  createEstateF(input: $input) {
    errorMessage
    item {
      address
      appearanceImgs
      area
      balconyArea
      bcr
      bldConditionType
      buildingCompany
      buildingFloors
      cadastralMapPdf
      carsInParkingN
      city
      cityPlanningType
      cleaningMonth
      clearingType
      collectedAt
      companyAddress
      companyBranchId
      companyFax
      companyGuaranter
      companyId
      companyLicense
      companyName
      companyRecNo
      companyTel
      companyUrl
      completionMonth
      completionMonthS
      completionSchMonth
      condominiumId
      condominiumName
      condominiumRecNo
      confirmed
      createdAt
      currentStatus
      currentStatusB
      currentStatusFree
      currentStatusG
      deletedOnSumora
      drivewayPay
      eSchool
      estatePrice
      estateType
      estateUrl
      exactLocation
      floor
      floorAreaRatio
      floorStructure
      fullAddress
      gas
      gasPdf
      groundPdf
      groundType
      groundTypeFree
      id
      infoName
      isLot
      jSchool
      landAreaType
      landRights
      latitude
      layout
      layoutImgs
      license
      location
      longitude
      managementFee
      managementType
      manager
      mapImg
      media
      mediationKind
      name
      nearlyLocation
      notFoundAt
      otherCost
      owner
      parking
      parkingFee
      parkingHeight
      parkingMechOrPlane
      parkingTakeOver
      parkingTakeOverFree
      pet
      prefecture
      priceHistory {
        price
        pricedAt
        __typename
      }
      pricedAt
      purposeB
      purposeSummaryB
      recNo
      remarks
      repairCost
      roadDirection
      roadType
      roadWidth
      room
      searchInfo
      seller
      sewer
      sewerPdf
      sold
      squareArea
      status
      store
      structure
      structureFree
      subCompany2Address
      subCompany2Fax
      subCompany2Guaranter
      subCompany2Id
      subCompany2License
      subCompany2Name
      subCompany2Tel
      subCompany2Url
      subCompanyAddress
      subCompanyFax
      subCompanyGuaranter
      subCompanyId
      subCompanyLicense
      subCompanyName
      subCompanyRecNo
      subCompanyTel
      subCompanyUrl
      tileOnZoom12
      tileOnZoom14
      tileOnZoom16
      totalArea
      totalHouses
      traffic
      tsuboArea
      unitPrice
      unsettledLocation
      updatedAt
      url
      useDistrict
      water
      waterPdf
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEstateFMutationVariables,
  APITypes.CreateEstateFMutation
>;
export const createPublicEstateF = /* GraphQL */ `mutation CreatePublicEstateF($input: CreatePublicEstateInput!) {
  createPublicEstateF(input: $input) {
    id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePublicEstateFMutationVariables,
  APITypes.CreatePublicEstateFMutation
>;
export const createPublicEstatePdfF = /* GraphQL */ `mutation CreatePublicEstatePdfF($input: CreatePublicEstatePdfInput!) {
  createPublicEstatePdfF(input: $input) {
    pdf
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePublicEstatePdfFMutationVariables,
  APITypes.CreatePublicEstatePdfFMutation
>;
export const createReport = /* GraphQL */ `mutation CreateReport(
  $condition: ModelReportConditionInput
  $input: CreateReportInput!
) {
  createReport(condition: $condition, input: $input) {
    companyId
    companyName
    createdAt
    description
    estateId
    estateName
    expiredAt
    id
    latitude
    longitude
    owner
    reportKind
    updatedAt
    userName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReportMutationVariables,
  APITypes.CreateReportMutation
>;
export const createScraping = /* GraphQL */ `mutation CreateScraping(
  $condition: ModelScrapingConditionInput
  $input: CreateScrapingInput!
) {
  createScraping(condition: $condition, input: $input) {
    baseUrl
    createdAt
    endedAt
    input
    operation
    output
    prefName
    remarks
    resultKey
    sortKey
    startedAt
    status
    totalCount
    updated {
      blocked
      expired
      newRecord
      onSite
      requiresAuth
      return
      returnAndUpdatePrice
      scrapingFailed
      updateFailed
      updatePrice
      __typename
    }
    updatedAt
    updating {
      blocked
      expired
      newRecord
      onSite
      requiresAuth
      return
      returnAndUpdatePrice
      scrapingFailed
      updateFailed
      updatePrice
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateScrapingMutationVariables,
  APITypes.CreateScrapingMutation
>;
export const createStickyNoteF = /* GraphQL */ `mutation CreateStickyNoteF($input: CreateStickyNoteInput!) {
  createStickyNoteF(input: $input) {
    errorMessage
    item {
      color
      companyId
      createdAt
      description
      icon
      id
      infoName
      latitude
      longitude
      memoKind
      openLevel
      owner
      searchInfo
      tileOnZoom12
      tileOnZoom14
      tileOnZoom16
      updatedAt
      url1
      url2
      url3
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStickyNoteFMutationVariables,
  APITypes.CreateStickyNoteFMutation
>;
export const deleteAnnounce = /* GraphQL */ `mutation DeleteAnnounce(
  $condition: ModelAnnounceConditionInput
  $input: DeleteAnnounceInput!
) {
  deleteAnnounce(condition: $condition, input: $input) {
    body
    createdAt
    expiredAt
    id
    level
    owner
    subject
    to
    updatedAt
    ym
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAnnounceMutationVariables,
  APITypes.DeleteAnnounceMutation
>;
export const deleteBatchJob = /* GraphQL */ `mutation DeleteBatchJob(
  $condition: ModelBatchJobConditionInput
  $input: DeleteBatchJobInput!
) {
  deleteBatchJob(condition: $condition, input: $input) {
    createdAt
    expiredAt
    id
    jobName
    remarks
    status
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBatchJobMutationVariables,
  APITypes.DeleteBatchJobMutation
>;
export const deleteBatchJobConf = /* GraphQL */ `mutation DeleteBatchJobConf(
  $condition: ModelBatchJobConfConditionInput
  $input: DeleteBatchJobConfInput!
) {
  deleteBatchJobConf(condition: $condition, input: $input) {
    allowedGroups
    createdAt
    jobName
    remarks
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBatchJobConfMutationVariables,
  APITypes.DeleteBatchJobConfMutation
>;
export const deleteBuildPrice = /* GraphQL */ `mutation DeleteBuildPrice(
  $condition: ModelBuildPriceConditionInput
  $input: DeleteBuildPriceInput!
) {
  deleteBuildPrice(condition: $condition, input: $input) {
    createdAt
    owner
    unitPriceCB
    unitPriceOther
    unitPriceRC
    unitPriceS
    unitPriceSRC
    unitPriceW
    updatedAt
    year
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBuildPriceMutationVariables,
  APITypes.DeleteBuildPriceMutation
>;
export const deleteCognitoUserF = /* GraphQL */ `mutation DeleteCognitoUserF($username: String!) {
  deleteCognitoUserF(username: $username) {
    errorMessage
    item {
      Attributes {
        Name
        Value
        __typename
      }
      Company {
        address
        areaNames
        areaPrefs
        areas
        bldConditionCompanies
        bldConditionSelections
        branchAddress
        branchFax
        branchId
        branchName
        branchTel
        branchUrl
        createdAt
        eAreaNames
        eAreas
        email
        estateTypes
        fax
        guaranter
        id
        infoName
        job
        latitude
        license
        licenseCount
        licenseNo
        licenser
        logoImg
        longitude
        name
        organization
        owner
        recNo
        remarks
        remarks2
        searchInfo
        startMark
        tel
        updatedAt
        url
        __typename
      }
      Enabled
      Groups {
        CreationDate
        Description
        GroupName
        LastModifiedDate
        Precedence
        RoleArn
        UserPoolId
        __typename
      }
      MFAOptions {
        AttributeName
        DeliveryMedium
        __typename
      }
      User {
        agreement
        authenticatedAt
        companyBranchName
        companyId
        companyName
        createdAt
        defaultCondition {
          alsoCreatedAtFrom
          alsoCreatedAtTo
          alsoPricedAtFrom
          alsoPricedAtTo
          areaPrefs
          areas
          bldConditionSelections
          companyRecNo
          completionYMFrom
          completionYMTo
          estatePriceFrom
          estatePriceTo
          estateTypes
          exceptForRent
          flat
          forRent
          petOk
          priceLabel
          purposeSummaryBs
          roomsFrom
          roomsTo
          squareAreaOfMansionFrom
          squareAreaOfMansionTo
          structureSummaries
          tsuboAreaFrom
          tsuboAreaTo
          tsuboLabel
          venderOnly
          __typename
        }
        email
        group
        infoName
        name
        nameRuby
        owner
        paid
        pricingAvailable
        role
        searchInfo
        tel
        trial
        trialEndAt
        updatedAt
        username
        __typename
      }
      UserCreateDate
      UserLastModifiedDate
      UserStatus
      Username
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCognitoUserFMutationVariables,
  APITypes.DeleteCognitoUserFMutation
>;
export const deleteCompanyF = /* GraphQL */ `mutation DeleteCompanyF($input: DeleteCompanyInput!) {
  deleteCompanyF(input: $input) {
    errorMessage
    item {
      address
      areaNames
      areaPrefs
      areas
      bldConditionCompanies
      bldConditionSelections
      branchAddress
      branchFax
      branchId
      branchName
      branchTel
      branchUrl
      createdAt
      eAreaNames
      eAreas
      email
      estateTypes
      fax
      guaranter
      id
      infoName
      job
      latitude
      license
      licenseCount
      licenseNo
      licenser
      logoImg
      longitude
      name
      organization
      owner
      recNo
      remarks
      remarks2
      searchInfo
      startMark
      tel
      updatedAt
      url
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCompanyFMutationVariables,
  APITypes.DeleteCompanyFMutation
>;
export const deleteDummy = /* GraphQL */ `mutation DeleteDummy(
  $condition: ModelDummyConditionInput
  $input: DeleteDummyInput!
) {
  deleteDummy(condition: $condition, input: $input) {
    createdAt
    id
    kintoneAppScope
    kintoneDataKind
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDummyMutationVariables,
  APITypes.DeleteDummyMutation
>;
export const deleteEstateF = /* GraphQL */ `mutation DeleteEstateF($input: DeleteEstateInput!) {
  deleteEstateF(input: $input) {
    errorMessage
    item {
      address
      appearanceImgs
      area
      balconyArea
      bcr
      bldConditionType
      buildingCompany
      buildingFloors
      cadastralMapPdf
      carsInParkingN
      city
      cityPlanningType
      cleaningMonth
      clearingType
      collectedAt
      companyAddress
      companyBranchId
      companyFax
      companyGuaranter
      companyId
      companyLicense
      companyName
      companyRecNo
      companyTel
      companyUrl
      completionMonth
      completionMonthS
      completionSchMonth
      condominiumId
      condominiumName
      condominiumRecNo
      confirmed
      createdAt
      currentStatus
      currentStatusB
      currentStatusFree
      currentStatusG
      deletedOnSumora
      drivewayPay
      eSchool
      estatePrice
      estateType
      estateUrl
      exactLocation
      floor
      floorAreaRatio
      floorStructure
      fullAddress
      gas
      gasPdf
      groundPdf
      groundType
      groundTypeFree
      id
      infoName
      isLot
      jSchool
      landAreaType
      landRights
      latitude
      layout
      layoutImgs
      license
      location
      longitude
      managementFee
      managementType
      manager
      mapImg
      media
      mediationKind
      name
      nearlyLocation
      notFoundAt
      otherCost
      owner
      parking
      parkingFee
      parkingHeight
      parkingMechOrPlane
      parkingTakeOver
      parkingTakeOverFree
      pet
      prefecture
      priceHistory {
        price
        pricedAt
        __typename
      }
      pricedAt
      purposeB
      purposeSummaryB
      recNo
      remarks
      repairCost
      roadDirection
      roadType
      roadWidth
      room
      searchInfo
      seller
      sewer
      sewerPdf
      sold
      squareArea
      status
      store
      structure
      structureFree
      subCompany2Address
      subCompany2Fax
      subCompany2Guaranter
      subCompany2Id
      subCompany2License
      subCompany2Name
      subCompany2Tel
      subCompany2Url
      subCompanyAddress
      subCompanyFax
      subCompanyGuaranter
      subCompanyId
      subCompanyLicense
      subCompanyName
      subCompanyRecNo
      subCompanyTel
      subCompanyUrl
      tileOnZoom12
      tileOnZoom14
      tileOnZoom16
      totalArea
      totalHouses
      traffic
      tsuboArea
      unitPrice
      unsettledLocation
      updatedAt
      url
      useDistrict
      water
      waterPdf
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEstateFMutationVariables,
  APITypes.DeleteEstateFMutation
>;
export const deleteReport = /* GraphQL */ `mutation DeleteReport(
  $condition: ModelReportConditionInput
  $input: DeleteReportInput!
) {
  deleteReport(condition: $condition, input: $input) {
    companyId
    companyName
    createdAt
    description
    estateId
    estateName
    expiredAt
    id
    latitude
    longitude
    owner
    reportKind
    updatedAt
    userName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteReportMutationVariables,
  APITypes.DeleteReportMutation
>;
export const deleteStickyNoteF = /* GraphQL */ `mutation DeleteStickyNoteF($input: DeleteStickyNoteInput!) {
  deleteStickyNoteF(input: $input) {
    errorMessage
    item {
      color
      companyId
      createdAt
      description
      icon
      id
      infoName
      latitude
      longitude
      memoKind
      openLevel
      owner
      searchInfo
      tileOnZoom12
      tileOnZoom14
      tileOnZoom16
      updatedAt
      url1
      url2
      url3
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteStickyNoteFMutationVariables,
  APITypes.DeleteStickyNoteFMutation
>;
export const incrementEstateAtomicCounterC = /* GraphQL */ `mutation IncrementEstateAtomicCounterC($id: String!) {
  incrementEstateAtomicCounterC(id: $id) {
    counterName
    createdAt
    kind
    sequence
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.IncrementEstateAtomicCounterCMutationVariables,
  APITypes.IncrementEstateAtomicCounterCMutation
>;
export const incrementRecNoAtomicCounterC = /* GraphQL */ `mutation IncrementRecNoAtomicCounterC {
  incrementRecNoAtomicCounterC {
    counterName
    createdAt
    kind
    sequence
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.IncrementRecNoAtomicCounterCMutationVariables,
  APITypes.IncrementRecNoAtomicCounterCMutation
>;
export const incrementSearchAtomicCounterC = /* GraphQL */ `mutation IncrementSearchAtomicCounterC {
  incrementSearchAtomicCounterC {
    counterName
    createdAt
    kind
    sequence
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.IncrementSearchAtomicCounterCMutationVariables,
  APITypes.IncrementSearchAtomicCounterCMutation
>;
export const incrementSiteAtomicCounterC = /* GraphQL */ `mutation IncrementSiteAtomicCounterC($site: String!) {
  incrementSiteAtomicCounterC(site: $site) {
    counterName
    createdAt
    kind
    sequence
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.IncrementSiteAtomicCounterCMutationVariables,
  APITypes.IncrementSiteAtomicCounterCMutation
>;
export const invokeExportUserCsv = /* GraphQL */ `mutation InvokeExportUserCsv($todayOnly: Boolean) {
  invokeExportUserCsv(todayOnly: $todayOnly)
}
` as GeneratedMutation<
  APITypes.InvokeExportUserCsvMutationVariables,
  APITypes.InvokeExportUserCsvMutation
>;
export const notifyEstateC = /* GraphQL */ `mutation NotifyEstateC($input: NotifyEstateInput!) {
  notifyEstateC(input: $input) {
    address
    appearanceImgs
    area
    balconyArea
    bcr
    bldConditionType
    buildingCompany
    buildingFloors
    cadastralMapPdf
    carsInParkingN
    city
    cityPlanningType
    cleaningMonth
    clearingType
    collectedAt
    companyAddress
    companyBranchId
    companyFax
    companyGuaranter
    companyId
    companyLicense
    companyName
    companyRecNo
    companyTel
    companyUrl
    completionMonth
    completionMonthS
    completionSchMonth
    condominiumId
    condominiumName
    condominiumRecNo
    confirmed
    createdAt
    currentStatus
    currentStatusB
    currentStatusFree
    currentStatusG
    deletedOnSumora
    drivewayPay
    eSchool
    estatePrice
    estateType
    estateUrl
    exactLocation
    floor
    floorAreaRatio
    floorStructure
    fullAddress
    gas
    gasPdf
    groundPdf
    groundType
    groundTypeFree
    id
    infoName
    isLot
    jSchool
    landAreaType
    landRights
    latitude
    layout
    layoutImgs
    license
    location
    longitude
    managementFee
    managementType
    manager
    mapImg
    media
    mediationKind
    name
    nearlyLocation
    notFoundAt
    otherCost
    owner
    parking
    parkingFee
    parkingHeight
    parkingMechOrPlane
    parkingTakeOver
    parkingTakeOverFree
    pet
    prefecture
    priceHistory {
      price
      pricedAt
      __typename
    }
    pricedAt
    purposeB
    purposeSummaryB
    recNo
    remarks
    repairCost
    roadDirection
    roadType
    roadWidth
    room
    searchInfo
    seller
    sewer
    sewerPdf
    sold
    squareArea
    status
    store
    structure
    structureFree
    subCompany2Address
    subCompany2Fax
    subCompany2Guaranter
    subCompany2Id
    subCompany2License
    subCompany2Name
    subCompany2Tel
    subCompany2Url
    subCompanyAddress
    subCompanyFax
    subCompanyGuaranter
    subCompanyId
    subCompanyLicense
    subCompanyName
    subCompanyRecNo
    subCompanyTel
    subCompanyUrl
    tileOnZoom12
    tileOnZoom14
    tileOnZoom16
    totalArea
    totalHouses
    traffic
    tsuboArea
    unitPrice
    unsettledLocation
    updatedAt
    url
    useDistrict
    water
    waterPdf
    __typename
  }
}
` as GeneratedMutation<
  APITypes.NotifyEstateCMutationVariables,
  APITypes.NotifyEstateCMutation
>;
export const resetTemporaryPasswordOfCognitoUserF = /* GraphQL */ `mutation ResetTemporaryPasswordOfCognitoUserF($username: String!) {
  resetTemporaryPasswordOfCognitoUserF(username: $username) {
    errorMessage
    item {
      Attributes {
        Name
        Value
        __typename
      }
      Company {
        address
        areaNames
        areaPrefs
        areas
        bldConditionCompanies
        bldConditionSelections
        branchAddress
        branchFax
        branchId
        branchName
        branchTel
        branchUrl
        createdAt
        eAreaNames
        eAreas
        email
        estateTypes
        fax
        guaranter
        id
        infoName
        job
        latitude
        license
        licenseCount
        licenseNo
        licenser
        logoImg
        longitude
        name
        organization
        owner
        recNo
        remarks
        remarks2
        searchInfo
        startMark
        tel
        updatedAt
        url
        __typename
      }
      Enabled
      Groups {
        CreationDate
        Description
        GroupName
        LastModifiedDate
        Precedence
        RoleArn
        UserPoolId
        __typename
      }
      MFAOptions {
        AttributeName
        DeliveryMedium
        __typename
      }
      User {
        agreement
        authenticatedAt
        companyBranchName
        companyId
        companyName
        createdAt
        defaultCondition {
          alsoCreatedAtFrom
          alsoCreatedAtTo
          alsoPricedAtFrom
          alsoPricedAtTo
          areaPrefs
          areas
          bldConditionSelections
          companyRecNo
          completionYMFrom
          completionYMTo
          estatePriceFrom
          estatePriceTo
          estateTypes
          exceptForRent
          flat
          forRent
          petOk
          priceLabel
          purposeSummaryBs
          roomsFrom
          roomsTo
          squareAreaOfMansionFrom
          squareAreaOfMansionTo
          structureSummaries
          tsuboAreaFrom
          tsuboAreaTo
          tsuboLabel
          venderOnly
          __typename
        }
        email
        group
        infoName
        name
        nameRuby
        owner
        paid
        pricingAvailable
        role
        searchInfo
        tel
        trial
        trialEndAt
        updatedAt
        username
        __typename
      }
      UserCreateDate
      UserLastModifiedDate
      UserStatus
      Username
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ResetTemporaryPasswordOfCognitoUserFMutationVariables,
  APITypes.ResetTemporaryPasswordOfCognitoUserFMutation
>;
export const saveDefaultConditionOfUserF = /* GraphQL */ `mutation SaveDefaultConditionOfUserF(
  $defaultCondition: DefaultConditionInput!
  $username: String!
) {
  saveDefaultConditionOfUserF(
    defaultCondition: $defaultCondition
    username: $username
  ) {
    errorMessage
    item {
      Attributes {
        Name
        Value
        __typename
      }
      Company {
        address
        areaNames
        areaPrefs
        areas
        bldConditionCompanies
        bldConditionSelections
        branchAddress
        branchFax
        branchId
        branchName
        branchTel
        branchUrl
        createdAt
        eAreaNames
        eAreas
        email
        estateTypes
        fax
        guaranter
        id
        infoName
        job
        latitude
        license
        licenseCount
        licenseNo
        licenser
        logoImg
        longitude
        name
        organization
        owner
        recNo
        remarks
        remarks2
        searchInfo
        startMark
        tel
        updatedAt
        url
        __typename
      }
      Enabled
      Groups {
        CreationDate
        Description
        GroupName
        LastModifiedDate
        Precedence
        RoleArn
        UserPoolId
        __typename
      }
      MFAOptions {
        AttributeName
        DeliveryMedium
        __typename
      }
      User {
        agreement
        authenticatedAt
        companyBranchName
        companyId
        companyName
        createdAt
        defaultCondition {
          alsoCreatedAtFrom
          alsoCreatedAtTo
          alsoPricedAtFrom
          alsoPricedAtTo
          areaPrefs
          areas
          bldConditionSelections
          companyRecNo
          completionYMFrom
          completionYMTo
          estatePriceFrom
          estatePriceTo
          estateTypes
          exceptForRent
          flat
          forRent
          petOk
          priceLabel
          purposeSummaryBs
          roomsFrom
          roomsTo
          squareAreaOfMansionFrom
          squareAreaOfMansionTo
          structureSummaries
          tsuboAreaFrom
          tsuboAreaTo
          tsuboLabel
          venderOnly
          __typename
        }
        email
        group
        infoName
        name
        nameRuby
        owner
        paid
        pricingAvailable
        role
        searchInfo
        tel
        trial
        trialEndAt
        updatedAt
        username
        __typename
      }
      UserCreateDate
      UserLastModifiedDate
      UserStatus
      Username
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SaveDefaultConditionOfUserFMutationVariables,
  APITypes.SaveDefaultConditionOfUserFMutation
>;
export const sendAnnounceMailF = /* GraphQL */ `mutation SendAnnounceMailF($input: SendAnnounceMailInput!) {
  sendAnnounceMailF(input: $input) {
    errorMessage
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SendAnnounceMailFMutationVariables,
  APITypes.SendAnnounceMailFMutation
>;
export const terminateTrialOfUserF = /* GraphQL */ `mutation TerminateTrialOfUserF($username: String!) {
  terminateTrialOfUserF(username: $username) {
    errorMessage
    item {
      Attributes {
        Name
        Value
        __typename
      }
      Company {
        address
        areaNames
        areaPrefs
        areas
        bldConditionCompanies
        bldConditionSelections
        branchAddress
        branchFax
        branchId
        branchName
        branchTel
        branchUrl
        createdAt
        eAreaNames
        eAreas
        email
        estateTypes
        fax
        guaranter
        id
        infoName
        job
        latitude
        license
        licenseCount
        licenseNo
        licenser
        logoImg
        longitude
        name
        organization
        owner
        recNo
        remarks
        remarks2
        searchInfo
        startMark
        tel
        updatedAt
        url
        __typename
      }
      Enabled
      Groups {
        CreationDate
        Description
        GroupName
        LastModifiedDate
        Precedence
        RoleArn
        UserPoolId
        __typename
      }
      MFAOptions {
        AttributeName
        DeliveryMedium
        __typename
      }
      User {
        agreement
        authenticatedAt
        companyBranchName
        companyId
        companyName
        createdAt
        defaultCondition {
          alsoCreatedAtFrom
          alsoCreatedAtTo
          alsoPricedAtFrom
          alsoPricedAtTo
          areaPrefs
          areas
          bldConditionSelections
          companyRecNo
          completionYMFrom
          completionYMTo
          estatePriceFrom
          estatePriceTo
          estateTypes
          exceptForRent
          flat
          forRent
          petOk
          priceLabel
          purposeSummaryBs
          roomsFrom
          roomsTo
          squareAreaOfMansionFrom
          squareAreaOfMansionTo
          structureSummaries
          tsuboAreaFrom
          tsuboAreaTo
          tsuboLabel
          venderOnly
          __typename
        }
        email
        group
        infoName
        name
        nameRuby
        owner
        paid
        pricingAvailable
        role
        searchInfo
        tel
        trial
        trialEndAt
        updatedAt
        username
        __typename
      }
      UserCreateDate
      UserLastModifiedDate
      UserStatus
      Username
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.TerminateTrialOfUserFMutationVariables,
  APITypes.TerminateTrialOfUserFMutation
>;
export const updateAnnounce = /* GraphQL */ `mutation UpdateAnnounce(
  $condition: ModelAnnounceConditionInput
  $input: UpdateAnnounceInput!
) {
  updateAnnounce(condition: $condition, input: $input) {
    body
    createdAt
    expiredAt
    id
    level
    owner
    subject
    to
    updatedAt
    ym
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAnnounceMutationVariables,
  APITypes.UpdateAnnounceMutation
>;
export const updateBatchJob = /* GraphQL */ `mutation UpdateBatchJob(
  $condition: ModelBatchJobConditionInput
  $input: UpdateBatchJobInput!
) {
  updateBatchJob(condition: $condition, input: $input) {
    createdAt
    expiredAt
    id
    jobName
    remarks
    status
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBatchJobMutationVariables,
  APITypes.UpdateBatchJobMutation
>;
export const updateBatchJobConf = /* GraphQL */ `mutation UpdateBatchJobConf(
  $condition: ModelBatchJobConfConditionInput
  $input: UpdateBatchJobConfInput!
) {
  updateBatchJobConf(condition: $condition, input: $input) {
    allowedGroups
    createdAt
    jobName
    remarks
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBatchJobConfMutationVariables,
  APITypes.UpdateBatchJobConfMutation
>;
export const updateBuildPrice = /* GraphQL */ `mutation UpdateBuildPrice(
  $condition: ModelBuildPriceConditionInput
  $input: UpdateBuildPriceInput!
) {
  updateBuildPrice(condition: $condition, input: $input) {
    createdAt
    owner
    unitPriceCB
    unitPriceOther
    unitPriceRC
    unitPriceS
    unitPriceSRC
    unitPriceW
    updatedAt
    year
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBuildPriceMutationVariables,
  APITypes.UpdateBuildPriceMutation
>;
export const updateCognitoUserF = /* GraphQL */ `mutation UpdateCognitoUserF(
  $agreement: Boolean
  $companyId: String!
  $email: AWSEmail!
  $group: String!
  $name: String!
  $nameRuby: String!
  $paid: Boolean
  $pricingAvailable: Boolean
  $role: String
  $tel: String
  $trial: Boolean
  $trialEndAt: AWSDateTime
  $username: String!
) {
  updateCognitoUserF(
    agreement: $agreement
    companyId: $companyId
    email: $email
    group: $group
    name: $name
    nameRuby: $nameRuby
    paid: $paid
    pricingAvailable: $pricingAvailable
    role: $role
    tel: $tel
    trial: $trial
    trialEndAt: $trialEndAt
    username: $username
  ) {
    errorMessage
    item {
      Attributes {
        Name
        Value
        __typename
      }
      Company {
        address
        areaNames
        areaPrefs
        areas
        bldConditionCompanies
        bldConditionSelections
        branchAddress
        branchFax
        branchId
        branchName
        branchTel
        branchUrl
        createdAt
        eAreaNames
        eAreas
        email
        estateTypes
        fax
        guaranter
        id
        infoName
        job
        latitude
        license
        licenseCount
        licenseNo
        licenser
        logoImg
        longitude
        name
        organization
        owner
        recNo
        remarks
        remarks2
        searchInfo
        startMark
        tel
        updatedAt
        url
        __typename
      }
      Enabled
      Groups {
        CreationDate
        Description
        GroupName
        LastModifiedDate
        Precedence
        RoleArn
        UserPoolId
        __typename
      }
      MFAOptions {
        AttributeName
        DeliveryMedium
        __typename
      }
      User {
        agreement
        authenticatedAt
        companyBranchName
        companyId
        companyName
        createdAt
        defaultCondition {
          alsoCreatedAtFrom
          alsoCreatedAtTo
          alsoPricedAtFrom
          alsoPricedAtTo
          areaPrefs
          areas
          bldConditionSelections
          companyRecNo
          completionYMFrom
          completionYMTo
          estatePriceFrom
          estatePriceTo
          estateTypes
          exceptForRent
          flat
          forRent
          petOk
          priceLabel
          purposeSummaryBs
          roomsFrom
          roomsTo
          squareAreaOfMansionFrom
          squareAreaOfMansionTo
          structureSummaries
          tsuboAreaFrom
          tsuboAreaTo
          tsuboLabel
          venderOnly
          __typename
        }
        email
        group
        infoName
        name
        nameRuby
        owner
        paid
        pricingAvailable
        role
        searchInfo
        tel
        trial
        trialEndAt
        updatedAt
        username
        __typename
      }
      UserCreateDate
      UserLastModifiedDate
      UserStatus
      Username
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCognitoUserFMutationVariables,
  APITypes.UpdateCognitoUserFMutation
>;
export const updateCompanyF = /* GraphQL */ `mutation UpdateCompanyF($input: UpdateCompanyInput!) {
  updateCompanyF(input: $input) {
    errorMessage
    item {
      address
      areaNames
      areaPrefs
      areas
      bldConditionCompanies
      bldConditionSelections
      branchAddress
      branchFax
      branchId
      branchName
      branchTel
      branchUrl
      createdAt
      eAreaNames
      eAreas
      email
      estateTypes
      fax
      guaranter
      id
      infoName
      job
      latitude
      license
      licenseCount
      licenseNo
      licenser
      logoImg
      longitude
      name
      organization
      owner
      recNo
      remarks
      remarks2
      searchInfo
      startMark
      tel
      updatedAt
      url
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCompanyFMutationVariables,
  APITypes.UpdateCompanyFMutation
>;
export const updateDummy = /* GraphQL */ `mutation UpdateDummy(
  $condition: ModelDummyConditionInput
  $input: UpdateDummyInput!
) {
  updateDummy(condition: $condition, input: $input) {
    createdAt
    id
    kintoneAppScope
    kintoneDataKind
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDummyMutationVariables,
  APITypes.UpdateDummyMutation
>;
export const updateEstateF = /* GraphQL */ `mutation UpdateEstateF($input: UpdateEstateInput!) {
  updateEstateF(input: $input) {
    errorMessage
    item {
      address
      appearanceImgs
      area
      balconyArea
      bcr
      bldConditionType
      buildingCompany
      buildingFloors
      cadastralMapPdf
      carsInParkingN
      city
      cityPlanningType
      cleaningMonth
      clearingType
      collectedAt
      companyAddress
      companyBranchId
      companyFax
      companyGuaranter
      companyId
      companyLicense
      companyName
      companyRecNo
      companyTel
      companyUrl
      completionMonth
      completionMonthS
      completionSchMonth
      condominiumId
      condominiumName
      condominiumRecNo
      confirmed
      createdAt
      currentStatus
      currentStatusB
      currentStatusFree
      currentStatusG
      deletedOnSumora
      drivewayPay
      eSchool
      estatePrice
      estateType
      estateUrl
      exactLocation
      floor
      floorAreaRatio
      floorStructure
      fullAddress
      gas
      gasPdf
      groundPdf
      groundType
      groundTypeFree
      id
      infoName
      isLot
      jSchool
      landAreaType
      landRights
      latitude
      layout
      layoutImgs
      license
      location
      longitude
      managementFee
      managementType
      manager
      mapImg
      media
      mediationKind
      name
      nearlyLocation
      notFoundAt
      otherCost
      owner
      parking
      parkingFee
      parkingHeight
      parkingMechOrPlane
      parkingTakeOver
      parkingTakeOverFree
      pet
      prefecture
      priceHistory {
        price
        pricedAt
        __typename
      }
      pricedAt
      purposeB
      purposeSummaryB
      recNo
      remarks
      repairCost
      roadDirection
      roadType
      roadWidth
      room
      searchInfo
      seller
      sewer
      sewerPdf
      sold
      squareArea
      status
      store
      structure
      structureFree
      subCompany2Address
      subCompany2Fax
      subCompany2Guaranter
      subCompany2Id
      subCompany2License
      subCompany2Name
      subCompany2Tel
      subCompany2Url
      subCompanyAddress
      subCompanyFax
      subCompanyGuaranter
      subCompanyId
      subCompanyLicense
      subCompanyName
      subCompanyRecNo
      subCompanyTel
      subCompanyUrl
      tileOnZoom12
      tileOnZoom14
      tileOnZoom16
      totalArea
      totalHouses
      traffic
      tsuboArea
      unitPrice
      unsettledLocation
      updatedAt
      url
      useDistrict
      water
      waterPdf
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEstateFMutationVariables,
  APITypes.UpdateEstateFMutation
>;
export const updateReport = /* GraphQL */ `mutation UpdateReport(
  $condition: ModelReportConditionInput
  $input: UpdateReportInput!
) {
  updateReport(condition: $condition, input: $input) {
    companyId
    companyName
    createdAt
    description
    estateId
    estateName
    expiredAt
    id
    latitude
    longitude
    owner
    reportKind
    updatedAt
    userName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReportMutationVariables,
  APITypes.UpdateReportMutation
>;
export const updateScraping = /* GraphQL */ `mutation UpdateScraping(
  $condition: ModelScrapingConditionInput
  $input: UpdateScrapingInput!
) {
  updateScraping(condition: $condition, input: $input) {
    baseUrl
    createdAt
    endedAt
    input
    operation
    output
    prefName
    remarks
    resultKey
    sortKey
    startedAt
    status
    totalCount
    updated {
      blocked
      expired
      newRecord
      onSite
      requiresAuth
      return
      returnAndUpdatePrice
      scrapingFailed
      updateFailed
      updatePrice
      __typename
    }
    updatedAt
    updating {
      blocked
      expired
      newRecord
      onSite
      requiresAuth
      return
      returnAndUpdatePrice
      scrapingFailed
      updateFailed
      updatePrice
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateScrapingMutationVariables,
  APITypes.UpdateScrapingMutation
>;
export const updateStickyNoteF = /* GraphQL */ `mutation UpdateStickyNoteF($input: UpdateStickyNoteInput!) {
  updateStickyNoteF(input: $input) {
    errorMessage
    item {
      color
      companyId
      createdAt
      description
      icon
      id
      infoName
      latitude
      longitude
      memoKind
      openLevel
      owner
      searchInfo
      tileOnZoom12
      tileOnZoom14
      tileOnZoom16
      updatedAt
      url1
      url2
      url3
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateStickyNoteFMutationVariables,
  APITypes.UpdateStickyNoteFMutation
>;
